import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import * as Raven from 'raven-js';
import {Observable} from 'rxjs/internal/Observable';
import {throwError} from 'rxjs/internal/observable/throwError';
import {LOCALE_PREFIX} from '../configs';
import {locationHref} from '../utils';

const JWT_KEY = '[girko] JWT token';
const authErrorPipe = environment.production ?
  catchError((err: HttpErrorResponse) => {
    if (err.status === 401) {
      const next = encodeURIComponent(location.pathname);
      locationHref(`/accounts/login/?next=${next}`);
    } else if (err.status !== 0 && err.status !== 402 && err.status !== 403) {
      const { error = {} } = err || {};
      Raven.captureException(JSON.stringify(error));
    }
    // if (err.status === 403 && err.error.detail === 'unverified email') {
    //   locationHref('/accounts/verify_email/');
    // }
    return throwError(err);
  }) :
  catchError((err: HttpErrorResponse) => {
    if (err.status === 401) {
      localStorage.removeItem(JWT_KEY);
      alert('Please login.');
    }
    return throwError(err);
  });

@Injectable()
export class AuthHttpService {
  constructor(private http: HttpClient) {}

  get<T>(url: string): Observable<T> {
    return this.http.get<T>(url, { headers: this.authHeader() }).pipe<T>(authErrorPipe);
  }

  patch<T>(url: string, data: any): Observable<T> {
    return this.http.patch<T>(url, data, { headers: this.authHeader() }).pipe<T>(authErrorPipe);
  }

  put<T>(url: string, data: any): Observable<T> {
    return this.http.put<T>(url, data, { headers: this.authHeader() }).pipe<T>(authErrorPipe);
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.http.post<T>(url, data, { headers: this.authHeader() }).pipe<T>(authErrorPipe);
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url, { headers: this.authHeader() }).pipe<T>(authErrorPipe);
  }

  getUrlPrefix() {
    return `${environment.urlPrefix}${LOCALE_PREFIX}`;
  }

  private authHeader() {
    if (environment.production) {
      return new HttpHeaders({
        'X-CSRFToken': getCookie('csrftoken'),
      });
    } else {
      const jwtToken = localStorage.getItem(JWT_KEY);

      return new HttpHeaders({
        Authorization: `JWT ${jwtToken}`,
      });
    }
  }
}

function getCookie(cname: string) {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
